;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type {TextField} from "@payloadcms/plugin-form-builder/types";
import type React from "react";
import type {FieldErrorsImpl, FieldValues, UseFormRegister,} from "react-hook-form";
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
import {Error} from "../Error/index";
import {Width} from "../Width/index";

export const Upload: React.FC<
	TextField & {
		errors: Partial<
			FieldErrorsImpl<{
				[x: string]: any;
			}>
		>;
		register: UseFormRegister<FieldValues>;
	}
> = ({
	name,
	defaultValue,
	errors,
	label,
	register,
	required: requiredFromProps,
	width,
}) => {
	return (
		<Width width={width}>
			<Label htmlFor={name}>{label}</Label>
			<Input
				defaultValue={defaultValue}
				id={name}
				type="file"
				{...register(name, { required: requiredFromProps })}
			/>
			{requiredFromProps && errors[name] && <Error />}
		</Width>
	);
};
